export default {
  namespaced: true,

  state: () => {
    return {
      receiverEmails: [],
      addedParticipants: [],
      subject: '',
      bodyText: '',
      showRecipientsList: false,
      pdfOnly: false,
      selectedItems: {
        plans: [],
        documents: [],
      },
    }
  },

  getters: {
    getSelectedAddedParticipants: (state) => {
      return state.addedParticipants.filter(p => state.receiverEmails.includes(p.user.email))
    },
  },

  mutations: {
    SET_RECEIVER_EMAILS (state, emails) {
      state.receiverEmails = emails
    },

    ADD_RECEIVER_EMAIL (state, email) {
      if (!state.receiverEmails.includes(email)) {
        state.receiverEmails.push(email)
      }
    },

    REMOVE_RECEIVER_EMAIL (state, email) {
      state.receiverEmails = state.receiverEmails.filter(e => e !== email)
    },

    SET_ADDED_PARTICIPANTS (state, participants) {
      state.addedParticipants = participants
    },

    ADD_ADDED_PARTICIPANT (state, participant) {
      if (!state.addedParticipants.some(p => p._id === participant._id)) {
        state.addedParticipants.push(participant)
      }
    },

    REMOVE_ADDED_PARTICIPANT (state, participantId) {
      state.addedParticipants = state.addedParticipants.filter(p => p._id !== participantId)
    },

    UPDATE_ADDED_PARTICIPANT (state, { _id, firstName, lastName, roles, email }) {
      const affectedParticipant = state.addedParticipants.find(participant => participant._id === _id)

      if (!affectedParticipant) {
        return
      }

      affectedParticipant.firstname = firstName
      affectedParticipant.lastname = lastName
      affectedParticipant.roles = roles
      affectedParticipant.user.email = email
    },

    SET_SUBJECT (state, subject) {
      state.subject = subject
    },

    SET_BODY_TEXT (state, bodyText) {
      state.bodyText = bodyText
    },

    SET_SHOW_RECIPIENTS_LIST (state, showRecipientsList) {
      state.showRecipientsList = showRecipientsList
    },

    SET_PDF_ONLY (state, pdfOnly) {
      state.pdfOnly = pdfOnly
    },

    SET_SELECTED_ITEMS (state, selectedItems) {
      state.selectedItems = selectedItems
    },

    SET_SELECTED_ITEMS_PLANS (state, plans) {
      state.selectedItems.plans = plans || []
    },

    SET_SELECTED_ITEMS_DOCUMENTS (state, documents) {
      state.selectedItems.documents = documents || []
    },

    SET_MAILER_DATA (state, {
      receiverEmails,
      addedParticipants,
      subject,
      bodyText,
      showRecipientsList,
      pdfOnly,
      selectedItems,
    }) {
      state.receiverEmails = receiverEmails || []
      state.addedParticipants = addedParticipants || []
      state.subject = subject || ''
      state.bodyText = bodyText || ''
      state.showRecipientsList = showRecipientsList || false
      state.pdfOnly = pdfOnly || false
      state.selectedItems.plans = selectedItems.plans || []
      state.selectedItems.documents = selectedItems.documents || []
    },

    FULL_RESET (state) {
      state.receiverEmails = []
      state.addedParticipants = []
      state.subject = ''
      state.bodyText = ''
      state.sendCopyToMyself = false
      state.showRecipientsList = false
      state.pdfOnly = false
      state.selectedItems = {
        plans: [],
        documents: [],
      }
    },
  },
}
